module.exports = __webpack_public_path__ + "img/icon-google-marker@3x.0805347f.png";